import type { LucideIcon } from 'lucide-react';
import type { ComponentProps, FunctionComponent } from 'react';

import { ctw } from '@/index';

export type IIconContainerProps = {
  size?: number;
  children: ReturnType<LucideIcon>;
} & ComponentProps<'div'>;

export const IconContainer: FunctionComponent<IIconContainerProps> = ({
  size = 24,
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      style={{
        width: size * 0.9,
        height: size * 0.9,
        ...props.style,
      }}
      className={ctw(
        'grid place-content-center rounded-full border border-white bg-slate-200 p-0.5',
        props?.className,
      )}
    >
      {children}
    </div>
  );
};
